import { logger } from '@adornis/base/logging.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { loadAndAssert } from '../authz/access.js';
import { Exam } from '../exam.js';
import { startWatcherForExam, stopWatcherForExam } from '../../server/suggestions/examStateWatcherManager.js';

export const startExamWatcherMutation = registerMutation({
  operationName: 'startExamWatcher',
  type: () => Boolean,
  params: [{ name: 'examId', type: () => String }],
  resolve: (examId: string) => async () => {
    if (!examId) throw new Error('examId required');
    // Outside the try: a denial must reach the caller, not be logged and turned into `false`.
    await loadAndAssert(Exam, examId, 'read', { _id: 1 });
    try {
      await startWatcherForExam(examId, { debounceMs: 100 });
      return true;
    } catch (err) {
      logger.error({ err, examId }, 'Failed to start watcher for exam');
      return false;
    }
  },
});

export const stopExamWatcherMutation = registerMutation({
  operationName: 'stopExamWatcher',
  type: () => Boolean,
  params: [{ name: 'examId', type: () => String }],
  resolve: (examId: string) => async () => {
    if (!examId) throw new Error('examId required');
    // Watchers are shared per exam, so a stranger must not be able to stop the owner's.
    await loadAndAssert(Exam, examId, 'read', { _id: 1 });
    try {
      stopWatcherForExam(examId);
      return true;
    } catch (err) {
      logger.error({ err, examId }, 'Failed to stop watcher for exam');
      return false;
    }
  },
});

export default { startExamWatcherMutation, stopExamWatcherMutation };
